<template>
	<div class="container mx-auto space">
		<!-- Banner start -->
		<AppBanner />
		<!-- Banner snd -->


    <br><br><br><br>
	</div>
</template>

<script>
import AppBanner from '@/components/Base/AppBanner';


export default {
	name: 'Home',
	components: {
		AppBanner,
	},
};
</script>

<style scoped></style>
